import React from 'react'
function RodinaSelection(props: any) {
    /*
    console.log("<RodinaSelection")
    console.log(props)
    */
    return(
        <span>
            {props.pouziti.map((pouz: any)=>
            <span className={props.sel_pouz==pouz.key?"filterBtnStyle filterBtnStyleSelected":"filterBtnStyle"} key={pouz.key} id={pouz.key} /*onClick={()=>console.log("propagate_up_ref("+props.sel_rod+"/"+pouz.key+")")}*/onClick={()=>props.propagate_up_ref(props.sel_rod,pouz.key)}>&nbsp;{pouz.value.toUpperCase()}&nbsp;</span>)}
        </span>
    )
}
export default RodinaSelection